export enum SessionStorageItems {
  NewSQLConsoleQuery = 'new-sql-console',
  SQLConsoleQuery = 'sql-console',
  UtmSource = 'utm_source',
}
